import React from 'react'
import { MagicSpinner } from 'react-spinners-kit'
import { useStyles } from './Styles'

export const ButtonLoader = ({ loading, size = 30 }) => {
  let classes = useStyles()
  return (
    <div className={classes.buttonLoaderWrapper}>
      <MagicSpinner
        size={size}
        color="#438fce"
        loading={loading}
      />
    </div>
  )
}
